import React from "react";
import { Timeline } from "antd";
import { Alert } from "reactstrap";

import ChangeLogItem from "./ChangeLogItem";
import EndItem from "./EndItem";

const ChangeLogs = ({ events }) => {
  console.log(events);
  if (events.length < 1) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        }}
      >
        <Alert color="primary">Asgje ne Program</Alert>
      </div>
    );
  }
  return (
    <Timeline>
      {events.map((event, index) => (
        <ChangeLogItem key={index} changeLog={event} />
      ))}
      <EndItem key={12000} changeLog={{}} />
    </Timeline>
  );
};

export default ChangeLogs;
